import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fetcher"
export default class extends Controller {
  static values = { method: { type: String, default: "GET" }, url: String, body: { type: Object, default: {} } }
  connect() {
  }

  submit({ params }) {
    event.preventDefault()

    let body = params.body || this.bodyValue
    let csrfToken = document.querySelector(`meta[name="csrf-token"]`).getAttribute('content');

    fetch(this.urlValue, {
      method: this.methodValue,
      headers: {
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Cache-Control': 'no-cache'
      },
      body: this.objectAsFormData(body)
    }).then(response => {
      if (response.status === 200) {
        response.text().then(html => {
          Turbo.renderStreamMessage(html)
        })
      }
    })
  }

  objectAsFormData(obj, fd = new FormData(), prefix = '') {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
          this.objectAsFormData(obj[key], fd, prefix + key + '[')
        } else {
          fd.append(prefix + key + ']', obj[key])
        }
      }
    }
    return fd
  }
  // submit({ params }) {
  //   Fetcher.submit({ method: this.methodValue, url: this.urlValue, body: params.body || this.bodyValue })
  // }
}